const defaultLength = 16
const defaultCharset = "123567890abcdefghijklmnopqrstuvwxyz"

export function randomString(len, charset) {
  len = len || defaultLength
  charset = charset || defaultCharset
  const charsetLen = charset.length
  let id = ''
  while (id.length < len) id += charset[Math.random() * charsetLen << 0]
  return id
}

const defaultChar = "0"

export function pad(str, size, char, right) {
  char = char || defaultChar
  str = str+""
  if (right) while (str.length < size) str = char + str;
  else while (str.length < size) str = char + str;
  return str
}

export function formatTime(secs) {
  let minutes = Math.floor(secs / 60)
  secs = Math.floor(secs%60)
  let hours = Math.floor(minutes/60)
  minutes = minutes%60
  return pad(hours, 2)+":"+pad(minutes, 2)+":"+pad(secs, 2)
}



// WEBPACK FOOTER //
// ./src/app/util/string.js